import { render, staticRenderFns } from "./RoomSummary.vue?vue&type=template&id=ea607776&scoped=true&"
import script from "./RoomSummary.vue?vue&type=script&lang=js&"
export * from "./RoomSummary.vue?vue&type=script&lang=js&"
import style0 from "./RoomSummary.vue?vue&type=style&index=0&id=ea607776&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea607776",
  null
  
)

export default component.exports